import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '@codex/icons';
import { Rating } from '@codex/basics';

const ReviewsWrapper = styled.div`
  margin-top: 8px;
  width: 100%;
  max-width: 256px;
    
  span {
    font-family: Helvetica;
    font-size: 14px;
  }  
    
  @media ${(props) => props.theme.breakpoints.tablet} {
    max-width: 220px;
    
    span {
      font-size: 11px;
    }  
  }
  
  @media ${(props) => props.theme.breakpoints.mobile} {
    max-width: 140px;
    
    span {
      font-size: 11px;
    }  
  }
`;

const Reviews = ({
  reviewsCount, rating
}) => (
  <ReviewsWrapper>
    <Rating
      icon={<Icon icon={'StarFull'} />}
      maxCount={5}
      ratingCount={reviewsCount}
      ratingValue={rating}
    />
  </ReviewsWrapper>
);

Reviews.propTypes = {
  reviewsCount: PropTypes.number.isRequired,
  rating: PropTypes.number.isRequired
};

export default Reviews;
